export default [
	{
		path: "/",
		name: "index",
		meta: {
			title: "草本投资",
			icon: "md-home",
		},
		component: () => import("@/views/index.vue"),
	},
	{
		path: "/about",
		name: "about",
		meta: {
			title: "关于我们-草本投资",
			icon: "md-home",
		},
		children: [
			{
				path: "/aboutUs",
				name: "aboutUs",
				meta: {
					title: "关于我们-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/about/index.vue"),
			},
			{
				path: "/founder",
				name: "founder",
				meta: {
					title: "创始人简介-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/about/founder.vue"),
			},
			{
				path: "/joinus",
				name: "joinUs",
				meta: {
					title: "加入我们-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/about/joinUs.vue"),
			},
			{
				path: "/culture",
				name: "culture",
				meta: {
					title: "公司文化-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/about/culture.vue"),
			},
			{
				path: "/honor",
				name: "honor",
				meta: {
					title: "公司荣誉-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/about/honor.vue"),
			},
			{
				path: "/news",
				name: "news",
				meta: {
					title: "公司动态-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/about/news.vue"),
			},
			{
				path: "/newsInfo",
				name: "newsInfo",
				meta: {
					title: "公司动态详情-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/about/newsInfo.vue"),
			},
			{
				path: "/organization",
				name: "organization",
				meta: {
					title: "组织架构-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/about/organization.vue"),
			},
		],
	},
	{
		path: "/team",
		name: "team",
		meta: {
			title: "投研团队-草本投资",
			icon: "md-home",
		},
		children: [
			{
				path: "/team",
				name: "teamIndexWeb",
				meta: {
					title: "投研团队-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/team/index.vue"),
			},
			{
				path: "/idea",
				name: "idea",
				meta: {
					title: "投资理念-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/team/idea.vue"),
			},
			{
				path: "/guide",
				name: "guide",
				meta: {
					title: "投研指引-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/team/guide.vue"),
			},
			{
				path: "/datasys",
				name: "dataSys",
				meta: {
					title: "数据系统-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/team/dataSys.vue"),
			},
		],
	},
	{
		path: "/product",
		name: "product",
		meta: {
			title: "产品与服务-草本投资",
			icon: "md-home",
		},
		children: [
			{
				path: "/product",
				name: "productIndexWeb",
				meta: {
					title: "产品与服务-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/product/index.vue"),
			},
			{
				path: "/productInfo",
				name: "productInfo",
				meta: {
					title: "产品详情-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/product/productInfo.vue"),
			},
			{
				path: "/notice",
				name: "notice",
				meta: {
					title: "公司公告-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/product/notice.vue"),
			},
			{
				path: "/noticeInfo",
				name: "noticeInfo",
				meta: {
					title: "公司公告详情-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/product/noticeInfo.vue"),
			},
			{
				path: "/education",
				name: "education",
				meta: {
					title: "投资者教育-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/product/education.vue"),
			},
			{
				path: "/educationInfo",
				name: "educationInfo",
				meta: {
					title: "投资者教育详情-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/product/educationInfo.vue"),
			},
			{
				path: "/contactus",
				name: "contactUs",
				meta: {
					title: "联系我们-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/product/contactUs.vue"),
			},
			{
				path: "/customer",
				name: "customer",
				meta: {
					title: "客户专区-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/product/customer.vue"),
			},
		],
	},
	{
		path: "/proFocus",
		name: "proFocus",
		meta: {
			title: "专业聚焦",
			icon: "md-home",
		},
		children: [
			{
				path: "/proFocus",
				name: "proFocusWeb",
				meta: {
					title: "专业聚焦-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/web/proFocus.vue"),
			},
			{
				path: "/proFocusInfo",
				name: "proFocusInfo",
				meta: {
					title: "专业聚焦详情-草本投资",
					icon: "md-home",
				},
				component: () => import("@/views/web/proFocusInfo.vue"),
			},
		],
	},
];
